<div style="float: right;" class="noprint"><button class="btn btn-danger" (click) = "print()">Print Pdf</button></div>
<br>
<div  class="hr-detail-bar"><hr></div>
<div class="col-sm-12" *ngIf = "ProductValues">
<table class="table">
    <thead class="thead-dark">
      <tr>
        <th>Product Name</th>
        <th>Product Description</th>
        <th>Product Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr  *ngFor = "let product of ProductValues">
        <td> {{ product.productName }} </td>
        <td> {{ product.productDescription }} </td>
        <td> {{ product.productAmount }} </td>
        </tr>
       </tbody>
       
  </table>
  <div class="total-value"><h3> Total Amount - {{ quotionService.total }} </h3></div>
</div>
 